import { ILineDrawable, instanceOfILineDrawable } from "../../../../base/domain/drawing";
import { ICopyLinkedCheckBehavior } from "../../../../documaker/domain/format/objects";
import { ICheckableObject, instanceOfICheckableObject } from "./ICheckableObject";

export interface ICircleSelectObject extends ICheckableObject, ILineDrawable {
  copyLinkedCheckBehavior: ICopyLinkedCheckBehavior;
}

export function instanceOfICircleSelectObject(instance: any): instance is ICircleSelectObject {
  return instance
      && (instance.copyLinkedCheckBehavior !== undefined)
      && instanceOfILineDrawable(instance)
      && instanceOfICheckableObject<ICircleSelectObject>(instance, "circleselect");
}
